/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:14:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import * as Query from '../queries';

export default ({ type, resource }) => {
  console.log({ type, resource });
  // override ra-data-graphql-simple predicted queries here e.g.
  // if (resource === 'User') {
  //   if (type === 'GET_ONE') {
  //     return Query.getOneUserQuery;
  //   }
  //   if (type === 'GET_LIST') {
  //     return Query.getListUserQuery;
  //   }
  // }

  if (resource === 'Evidence' && type === 'GET_ONE') {
    return Query.getOneEvidence;
  }
  if (resource === 'PlotEvidence' && type === 'GET_MANY_REFERENCE') {
    return Query.getPlotEvidencesQuery;
  }
  if (resource === 'Event' && type === 'GET_LIST') {
    return Query.getEventListQuery;
  }
  if (resource === 'Event' && type === 'GET_ONE') {
    return Query.getOneEvent;
  }
  if (resource === 'EventEvidence' && type === 'GET_LIST') {
    return Query.getEventEvidenceListQuery;
  }
  if (resource === 'EventEvidence' && type === 'GET_MANY_REFERENCE') {
    return Query.getEventEvidenceListQuery;
  }
  if (resource === 'Plot' && type === 'GET_ONE') {
    return Query.getOnePlot;
  }
  if (resource === 'EventSuperSleuth' && type === 'GET_MANY_REFERENCE') {
    return Query.getEventSuperSleuthListQuery;
  }
  if (resource === 'Feedback' && type === 'GET_LIST') {
    return Query.getFeedbackListQuery;
  }
};
